<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Workday"
      text="Update workday"
      class="mb-0"
      :loading="loading"
    >
      <div v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localWorkSessionType"
                :items="workSessionTypes"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                label="Workday Type"
                outlined
                @change="workSessionDetails"
              />
            </v-col>

            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Monday"
                disabled
                outlined
                :value="formSession.monSession"
              />
            </v-col>

            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.monLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('monday session')"
                data-vv-name="monday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                hide-selected
                outlined
              />
            </v-col>
            
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Tuesday"
                disabled
                outlined
                :value="formSession.tueSession"
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.tueLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('tuesday session')"
                data-vv-name="tuesday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                outlined
                hide-selected
              />
            </v-col>
        
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Wednesday"
                disabled
                outlined
                :value="formSession.wedSession"
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.wedLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('wednesday session')"
                data-vv-name="wednesday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                hide-selected
                outlined
              />
            </v-col>
          
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Thursday"
                disabled
                :value="formSession.thuSession"
                outlined
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.thuLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('thursday session')"
                data-vv-name="thursday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                hide-selected
                outlined
              />
            </v-col>
        
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Friday"
                disabled
                outlined
                :value="formSession.friSession"
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.friLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('friday session')"
                data-vv-name="friday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                hide-selected
                outlined
              />
            </v-col>
            
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Saturday"
                disabled
                outlined
                :value="formSession.satSession"
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.satLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('saturday session')"
                data-vv-name="saturday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                hide-no-data
                return-object
                hide-selected
                outlined
              />
            </v-col>
            
            <v-col
              cols="6"
              class="py-0"
            >
              <v-text-field
                label="Sunday"
                disabled
                outlined
                :value="formSession.sunSession"
              />
            </v-col>
            <v-col
              cols="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="formSession.sunLeaveSession"
                v-validate="'required'"
                :items="leaveSessions"
                :error-messages="errors.collect('sunday session')"
                data-vv-name="sunday session"
                label="Leave Session"
                item-text="name"
                item-value="id"
                return-object
                hide-no-data
                hide-selected
                outlined
              />
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions v-if="dialog && !loading">
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"  
            class="white--text px-10"    
            @click="submitForm"
          >
            Update
          </v-btn>
        </v-card-actions>
      </div>
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        dialog: false,
        workSessionType: null,
        localWorkSessionType: null,
        progressing: false,
        workSessionTypes: [],
        leaveSessions: [],
        formSession: {
          monSession: '',
          tueSession: '',
          wedSession: '',
          thuSession: '',
          friSession: '',
          satSession: '',
          sunSession: '',
        },
      }
    },
    computed: {
      isSessionChanged () {
        return this.workSessionType === this.localWorkSessionType
      },
      selectedWorkSessionType () {
        return this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.localWorkSessionType })
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        Promise.all([
          this.$api.workSessionTypes().list(),
          this.$api.hrisEmployeeWorkDays().list(this.employeeUid),
          this.$api.hrisLeaveSessions().list(),
        ])
          .then(([ workSessionType, employeeWorkDay, leaveSession ]) => {
            this.workSessionTypes = workSessionType.data
            this.localWorkSessionType = employeeWorkDay.data[0].work_session.work_session_type_id
            this.workSessionType = employeeWorkDay.data[0].work_session.work_session_type_id
        
            this.workSessionDetailsDisplay(employeeWorkDay.data, true)

            this.formatLeaveSessionName(leaveSession.data)

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            if (!this.isSessionChanged) {
              this.$api.hrisEmployeeWorkDays().create(this.employeeUid, this.prepareStoreWorkdayForm())
                .then(response => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ message: 'Employee Workday updated' })

                    this.setProgressing(false)
                    this.dialog = false
                  }
                })
            } else {
              this.$api.hrisEmployeeWorkDays().update(this.employeeUid, this.prepareUpdateWorkdayForm())
                .then(response => {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                })
            }
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareStoreWorkdayForm () {
        return [
          {
            day: 1,
            work_session_id: this.selectedWorkSessionType.work_sessions[0].id,
            leave_session_id: ((this.formSession.monLeaveSession).id || this.formSession.monLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 2,
            work_session_id: this.selectedWorkSessionType.work_sessions[1].id,
            leave_session_id: ((this.formSession.tueLeaveSession).id || this.formSession.tueLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 3,
            work_session_id: this.selectedWorkSessionType.work_sessions[2].id,
            leave_session_id: ((this.formSession.wedLeaveSession).id || this.formSession.wedLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 4,
            work_session_id: this.selectedWorkSessionType.work_sessions[3].id,
            leave_session_id: ((this.formSession.thuLeaveSession).id || this.formSession.thuLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 5,
            work_session_id: this.selectedWorkSessionType.work_sessions[4].id,
            leave_session_id: ((this.formSession.friLeaveSession).id || this.formSession.friLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 6,
            work_session_id: this.selectedWorkSessionType.work_sessions[5].id,
            leave_session_id: ((this.formSession.satLeaveSession).id || this.formSession.satLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 7,
            work_session_id: this.selectedWorkSessionType.work_sessions[6].id,
            leave_session_id: ((this.formSession.sunLeaveSession).id || this.formSession.sunLeaveSession),
            is_payroll_fullday: 0,
          },
         
        ]
      },
      prepareUpdateWorkdayForm () {
        return [
          {
            day: 1,
            leave_session_id: ((this.formSession.monLeaveSession).id || this.formSession.monLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 2,
            leave_session_id: ((this.formSession.tueLeaveSession).id || this.formSession.tueLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 3,
            leave_session_id: ((this.formSession.wedLeaveSession).id || this.formSession.wedLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 4,
            leave_session_id: ((this.formSession.thuLeaveSession).id || this.formSession.thuLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 5,
            leave_session_id: ((this.formSession.friLeaveSession).id || this.formSession.friLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 6,
            leave_session_id: ((this.formSession.satLeaveSession).id || this.formSession.satLeaveSession),
            is_payroll_fullday: 0,
          },
          {
            day: 7,
            leave_session_id: ((this.formSession.sunLeaveSession).id || this.formSession.sunLeaveSession),
            is_payroll_fullday: 0,
          },
        ]
      },
      formatLeaveSessionName (data) {
        this.leaveSessions = data
           
        data.forEach(item => {
          if (item.name === 'None') {
            item.name = 'No Restriction'
          } else if (item.name === 'A.M') {
            item.name = 'A.M only'
          } else if (item.name === 'P.M') {
            item.name = 'P.M only'
          } else {
            item.name = 'Full Day'
          }
        })
      },
      workSessionDetails () {
        let workSessionType = this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.localWorkSessionType })
        this.workSessionDetailsDisplay(workSessionType.work_sessions, false)
      },
      workSessionDetailsDisplay (data, flag) {
        if (flag) {
          this.formSession.monSession = this.$moment(data[0].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[0].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.tueSession = this.$moment(data[1].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[1].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.wedSession = this.$moment(data[2].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[2].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.thuSession = this.$moment(data[3].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[3].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.friSession = this.$moment(data[4].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[4].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.satSession = this.$moment(data[5].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[5].work_session.end_time, 'hh:mm').format('hh:mm A')
          this.formSession.sunSession = this.$moment(data[6].work_session.start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[6].work_session.end_time, 'hh:mm').format('hh:mm A')
        
          this.formSession.monLeaveSession = data[0].leave_session_id
          this.formSession.tueLeaveSession = data[1].leave_session_id
          this.formSession.wedLeaveSession = data[2].leave_session_id
          this.formSession.thuLeaveSession = data[3].leave_session_id
          this.formSession.friLeaveSession = data[4].leave_session_id
          this.formSession.satLeaveSession = data[5].leave_session_id
          this.formSession.sunLeaveSession = data[6].leave_session_id
        } else {
          this.formSession.monSession = this.$moment(data[0].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[0].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.tueSession = this.$moment(data[1].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[1].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.wedSession = this.$moment(data[2].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[2].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.thuSession = this.$moment(data[3].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[3].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.friSession = this.$moment(data[4].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[4].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.satSession = this.$moment(data[5].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[5].end_time, 'hh:mm').format('hh:mm A')
          this.formSession.sunSession = this.$moment(data[6].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(data[6].end_time, 'hh:mm').format('hh:mm A')
        }
      },
    },
  }
</script>
